import settings from "../../../constants/settings";
import useFetchAndTrace from "../fetchWithTrace";
import { useState } from "react";

export interface AllocationUpdate {
  flashpcb_container_barcode: string;
  board_id: string;
  shipment_id: string;
  new_allocated_amount: number;
  old_allocated_amount: number;
}

export interface SpentAllocation {
  flashpcb_container_barcode: string;
  board_id: string;
  shipment_id: string;
  quantity_spent: number;
  quantity_allocated: number;
}

export default function useUpdateAllocation(
  onSuccess?: () => void,
  onError?: (detail: string) => void,
) {
  const [loading, setLoading] = useState<boolean>(false);
  const fetchAndTrace = useFetchAndTrace();

  const errorHandler = () => {
    setLoading(false);
    if (onError) {
      onError("Failed to update allocations for this container");
    }
  };

  const allocateContainerHandler = async (response: Response) => {
    setLoading(false);
    if (response.ok) {
      if (onSuccess) {
        onSuccess();
      }
    } else if (response.status === 400) {
      const { detail } = (await response.json()) as { detail: string };
      onError?.(detail);
    } else {
      throw Error("Unable to update allocations for this container");
    }
  };

  const updateAllocation = (allocationsUpdate: AllocationUpdate) => {
    setLoading(true);
    void fetchAndTrace(
      `${settings.api_url}/inventory/containers/update-allocation`,
      allocateContainerHandler,
      errorHandler,
      {
        body: JSON.stringify(allocationsUpdate),
        method: "PUT",
      },
    );
  };

  const markAllocationAsSpent = (allocationUpdate: SpentAllocation) => {
    setLoading(true);
    void fetchAndTrace(
      `${settings.api_url}/inventory/containers/mark-allocation-as-spent`,
      allocateContainerHandler,
      errorHandler,
      {
        body: JSON.stringify(allocationUpdate),
        method: "PUT",
      },
    );
  };

  return { updateAllocation, markAllocationAsSpent, loading };
}
